export default __webpack_public_path__ + "static/media/info-planning.e2315c47.jpg";